module.exports = __webpack_public_path__ + "static/media/move.929662bf.svg";